/*
  London & Co. — live bag count in the header.

  Dawn keeps its header count fresh by re-rendering the `cart-icon-bubble`
  section after every cart change (see getSectionsToRender in cart-drawer.js
  and cart.js). This theme's header is custom and renders `.lc-header__bag`
  instead, so that re-render targets an element id that isn't in the DOM.
  cart-drawer.js guards with `sectionElement && ...`, so it silently does
  nothing and the header keeps showing the count from the last page load —
  add an item and the header still reads Bag (0) until you navigate.

  Rather than reshape the header to Dawn's markup (which would change the
  design), subscribe to the `cart-update` event the theme already publishes
  from product-form.js and cart.js, and refresh the number in place.

  The count comes from /cart.js rather than the event payload: on add the
  payload is the line item, not the cart, so it carries no item_count.
*/
(function () {
  var SELECTOR = '.lc-header__bag';

  var COUNT_RE = /\(\d+\)\s*$/;

  function paint(count) {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var text = el.textContent;
      // Swap the number in place so the header keeps whatever it calls the
      // bag; only name it ourselves if there was no "(n)" to replace.
      el.textContent = COUNT_RE.test(text)
        ? text.replace(COUNT_RE, '(' + count + ')')
        : 'Bag (' + count + ')';
    }
  }

  function refresh() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') paint(cart.item_count);
      })
      .catch(function () {
        /* leave the server-rendered count alone if the cart can't be read */
      });
  }

  if (typeof subscribe === 'function') subscribe('cart-update', refresh);

  // Restoring from bfcache replays a DOM snapshot, which can carry a count
  // from before the cart changed in another tab.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
})();
